import script from "./HomeAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAbout.vue?vue&type=script&setup=true&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=3508a12e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3508a12e"]])

export default __exports__